import { handleReorder } from './handleReorder';
export const onReorder = ({
  options = [],
  setOptions = () => {}
}) => (draggedItem, droppedItem) => {
  const newOrder = handleReorder(options)(draggedItem, droppedItem);
  setOptions(newOrder);
};